module.exports = __webpack_public_path__ + "assets/img/69_319_2.1c60d9d3.jpg";